export const ApiCenterSources = Object.freeze({
    ext_combell_domain: 'Combell domains',
    ext_combell_hosting: 'Combell hostings',
});
